import React, { Component } from 'react'
import { Link } from 'react-router'
import { Grid, Menu } from 'semantic-ui-react'

export function SideNav (props) {
  return (
    <Menu secondary vertical>
      <Link className='item' activeClassName='active' to='/issues/overview'>Activity</Link>
      <Link className='item' activeClassName='active' to='/issues/settings'>Settings</Link>
    </Menu>
  )
}

export default class SettingsLayout extends Component {
  render () {
    const {children} = this.props

    return (
      <Grid>
        <Grid.Row style={{position: 'absolute', left: '0'}}>
          {/* <Grid.Column mobile={16} width={4} computer={4}>
            <SideNav />
          </Grid.Column>
          <Grid.Column mobile={16} width={12} computer={12}> */}
          <Grid.Column mobile={16} width={16} computer={16}>
            {children}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/issues/layout.js